// @ts-nocheck
import { useState, useEffect } from 'react';
import { pwaInstallManager } from '../../services/pwaInstallManager';
import PropTypes from 'prop-types';
import { DownloadSimple } from '@phosphor-icons/react';
import './InstallBanner.css';

/**
 * Install Banner Component
 * Shows installation prompt above bottom navigation on mobile/tablet
 */
const InstallBanner = ({ onInstallClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isEligible, setIsEligible] = useState(false);

  useEffect(() => {
    // Check initial eligibility
    checkEligibility();

    // Listen for install events
    const handleInstallable = () => {
      checkEligibility();
    };

    const handleInstalled = () => {
      setIsVisible(false);
      setIsEligible(false);
    };

    window.addEventListener('pwaInstallable', handleInstallable);
    window.addEventListener('pwaInstalled', handleInstalled);

    return () => {
      window.removeEventListener('pwaInstallable', handleInstallable);
      window.removeEventListener('pwaInstalled', handleInstalled);
    };
  }, []);

  const checkEligibility = () => {
    const eligible =
      pwaInstallManager.isEligibleForPrompt() &&
      (pwaInstallManager.isInstallable ||
        pwaInstallManager.supportsManualInstall());

    setIsEligible(eligible);
    setIsVisible(eligible);
  };

  const handleInstall = () => {
    if (onInstallClick) {
      onInstallClick();
    }
  };

  if (!isVisible || !isEligible) {
    return null;
  }

  return (
    <div className='install-banner'>
      <div className='install-banner__content'>
        <div className='install-banner__text'>
          <div className='install-banner__title'>
            Save for quick & offline access
          </div>
        </div>
        <button
          className='install-banner__install-btn'
          onClick={handleInstall}
          aria-label='Install app'
        >
          <DownloadSimple size={16} weight='bold' />
          Install
        </button>
      </div>
    </div>
  );
};

InstallBanner.propTypes = {
  onInstallClick: PropTypes.func
};

export default InstallBanner;
